/**
 * Vehicle maintenance status values
 */
export enum VehicleMaintenanceStatusEnum {
	/**
	 * Vehicle maintenance is pending
	 */
	PENDING = 'pending',
	/**
	 * Vehicle maintenance is in progress
	 */
	IN_PROGRESS = 'in_progress',
	/**
	 * Vehicle maintenance is completed
	 */
	COMPLETED = 'completed',
	/**
	 * Vehicle maintenance is cancelled
	 */
	CANCELLED = 'cancelled',
}
